import { CommonModule } from '@angular/common';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { AuthenticationService } from '@core/authentication/authentication.service';
import { AuthStateService } from '@core/authentication/auth-state.service';

import { AuthenticationInterceptor } from './authentication.interceptor';

@NgModule({ declarations: [],
    exports: [], imports: [CommonModule], providers: [
        {
            provide: HTTP_INTERCEPTORS,
            useClass: AuthenticationInterceptor,
            multi: true,
        },
        AuthenticationService,
        AuthStateService,
        provideHttpClient(withInterceptorsFromDi()),
    ] })
export class AuthenticationModule {}
